import Vue from 'vue'
import Router from 'vue-router'
import departures from './pages/departures'
import reservations from './pages/reservations'
import previews from './pages/previews'
import Index from './pages/main/Index'
import Login from './pages/main/Login'

Vue.use(Router)

export default new Router({
  linkActiveClass: 'active',
  base: process.env.BASE_URL,
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Index,
      children: [...departures, ...reservations, ...previews]
    },
    {
      path: '/login/:fullPath?',
      name: 'login',
      component: Login
    },
    { path: '*', redirect: '/' }
  ]
})
